import { ranking } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const trendConfig: Record<string, { icon: string; className: string }> = {
  up: { icon: "ri-arrow-up-line", className: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", className: "text-secondary-500" },
  flat: { icon: "ri-subtract-line", className: "text-foreground-400" },
};

export default function Ranking() {
  return (
    <section id="ranking" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <SectionHeading
            label="Hot Ranking"
            title="热瓜榜单：现在最烫的几条"
            desc="按实时讨论量排序，每小时刷新一次，方便一眼判断该先看哪一条。"
          />

          <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
            <div className="lg:col-span-1">
              <div className="h-full rounded-lg bg-primary-600 text-background-50 p-6 md:p-7 flex flex-col justify-between">
                <div>
                  <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-primary-100 mb-5">
                    <i className="ri-fire-fill"></i>
                    榜单速览
                  </span>
                  <p className="font-heading text-2xl md:text-3xl font-bold leading-snug mb-4">
                    前 3 名基本代表了当天大部分讨论走向
                  </p>
                  <p className="text-sm text-background-100/85 leading-relaxed">
                    黑料网吃瓜速览不止给热度数字，还标出方向：上升说明还在发酵，下降代表讨论开始回落。
                  </p>
                </div>
                <div className="mt-8 pt-5 border-t border-background-50/25 flex items-center justify-between text-sm">
                  <span className="text-background-100/85">下一次刷新</span>
                  <span className="inline-flex items-center gap-2">
                    <i className="ri-time-line"></i>
                    00:42
                  </span>
                </div>
              </div>
            </div>

            <div className="lg:col-span-2">
              <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                {ranking.map((item, index) => {
                  const trend = trendConfig[item.trend];
                  const isTopThree = item.rank <= 3;
                  return (
                    <a
                      key={item.rank}
                      href="#covers"
                      className={`group grid grid-cols-[auto_1fr_auto] items-center gap-3 md:gap-5 px-4 md:px-6 py-4 cursor-pointer transition-colors hover:bg-background-50 ${
                        index !== 0 ? "border-t border-background-200" : ""
                      }`}
                    >
                      <span
                        className={`font-heading text-xl md:text-2xl font-bold w-7 md:w-9 tabular-nums ${
                          isTopThree ? "text-primary-600" : "text-foreground-400"
                        }`}
                      >
                        {item.rank}
                      </span>
                      <div className="min-w-0">
                        <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                          {item.title}
                        </h3>
                        <span className="text-xs text-foreground-500">{item.category}</span>
                      </div>
                      <div className="flex items-center gap-3 md:gap-4">
                        <span className="text-xs md:text-sm text-foreground-600 tabular-nums inline-flex items-center gap-1">
                          <i className="ri-fire-line text-accent-600"></i>
                          {item.heat}
                        </span>
                        <i className={`${trend.icon} text-base ${trend.className}`}></i>
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}